const b = ["#cf8207", "#ebe0c6", "#1b4b96"], c = ["#cf8207", "#f5d185", "#ebe0c6", "#b4c4df", "#1b4b96"], e = [
  "#cf8207",
  "#eeb353",
  "#fceeb6",
  "#ebe0c6",
  "#c6d4eb",
  "#a2b4d2",
  "#1b4b96"
];
export {
  b as DIVERGING_ORANGE_BLUE_3,
  c as DIVERGING_ORANGE_BLUE_5,
  e as DIVERGING_ORANGE_BLUE_7
};
//# sourceMappingURL=index.es5700.js.map
